import React from 'react';
import IDynamicFormRow from '../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import FormTextBox from '../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox';
import FormSelect from '../yoello-lib/modules/dynamicForms/FormComponents/FormSelect';
import FormImageManipulator from '../yoello-lib/modules/components/ImageManipulator/FormImageManipulator';
import DynamicFormExtender from '../yoello-lib/modules/dynamicForms/DynamicFormExtender';
import PricingOption from '../yoello-lib/modules/dynamicForms/CustomFormComponents/PricingOptions';
import ExtrasFormComponent from '../components/menu/products/extras/ExtrasFormComponent';
import FormSwitchWithText from '../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText';
import { FormDnDList } from '../yoello-lib/modules/components/selectDndList/DnDList';
import ISubCategory from '../components/menu/categories/ISubCategory';
import { createPricingOption, ProductModifyDialog } from '../components/menu/products/ProductModifyDialog';
import { ITaxes } from '../interfaces/ITaxes';
import { FormTags } from '../yoello-lib/modules/dynamicForms/CustomFormComponents/FormTags';
import { IPreference } from '../components/menu/preferences/PreferenceForm';
import { IExtraGroup } from '../interfaces/IExtraGroup';
import { DeleteItems } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/DeleteItems";
import FormTitle from '../yoello-lib/modules/dynamicForms/FormComponents/FormTitle';
import { IMenuData } from '../components/manageMenu/types';


export function getModifyProductsFormRows(props: any, taxes: ITaxes[],
    subcategories: ISubCategory[], isEposNow: boolean, extraItems: IExtraGroup[], preferenceItems: IPreference[], dietaryTags: IItemTags[], menusList?: IMenuData[], removeAddToExtraGroup?: boolean, onDelete?: () => void , onFailedInteraction?:Function): IDynamicFormRow[] {

    let formRows: IDynamicFormRow[] = [
        // Option supplied dynamically
        {
            label: "menu.subcategories.generalInfo",
            Component: (props: any) => <FormTitle title={props.label} />,
            keyName: "details-subheading",

        },
        {
            label: "forms.modify.productname",
            keyName: "name_public",
            Component: FormTextBox,
            registerOptions:
            {
                required: true
            },
            inputProperties: {
                variant: 'outlined',
            },
            gridColumnOptions: { formCol: 6 },
            // disabled: isEposNow

        },
        {
            label: "menu.modify.intername",
            keyName: "name_internal",
            Component: FormTextBox,
            registerOptions:
            {
                required: true
            },
            inputProperties: {
                variant: 'outlined',
            },
            gridColumnOptions: { formCol: 6 },

        },
        {
            label: "forms.modify.productsubcat",
            keyName: "subcategory_id",
            Component: FormSelect,
            formProps: {
                selectOptions: subcategories.map((cat: ISubCategory) => { return { name: cat.subcategory_name, value: cat.id }; })
            },
            registerOptions:
            {
                required: true
            },
            inputProperties: {
                variant: 'outlined',
            },

        },
        {
            label: "forms.modify.description",
            keyName: "description",
            Component: FormTextBox,
            inputProperties:
            {
                multiline: true,
                rows: 4,
                variant: 'outlined'
            },
        },

        {
            label: "menu.subcategories.details",
            Component: (props: any) => <FormTitle title={props.label} />,
            keyName: "details-subheading",

        },
        {
            label: "menu.modify.abv", keyName: "abv",
            Component: FormTextBox,
            inputProperties: {
                variant: 'outlined',
                type: "number", inputProps: { step: 0.1, min: 0 }
            },
            registerOptions: { min: 0, max: 100 },
            gridColumnOptions: {
                formCol: 6
            },
        },
        {
            label: "menu.modify.taxband",
            keyName: "item_taxes",
            Component: FormTags,
            formProps: {
                selectOptions: taxes as any[],
                getOptionLabel: (option: ITaxes) => option.tax_band_name,
                multiple: true,
                selectKeyValue: "id"
            },
            gridColumnOptions: {
                formCol: 6
            },
            // disabled: isEposNow

        },
        {
            keyName: 'menu_products_divider',
            Component: () => <div></div>,
            label: "",
            gridColumnOptions: {
                formCol: 12
            },
        },
        {
            label: "menu.modify.instock",
            Component: FormSwitchWithText,
            formProps: {
                // secondLabel: "menu.modify.instock",
            },
            gridColumnOptions: {
                formCol: 6
            },
            // type: "switchWithText",
            keyName: "enabled",
        },
        {
            label: "menu.modify.delivery",
            Component: FormSwitchWithText,
            formProps: {
                // secondLabel: "menu.modify.delivery",
            },
            keyName: "delivery_enabled",
            gridColumnOptions: {
                formCol: 6
            },
        },
        {
            label: "menu.modify.tableService",
            Component: FormSwitchWithText,
            formProps: {
                // secondLabel: "menu.modify.delivery",
            },
            gridColumnOptions: {
                formCol: 6
            },
            keyName: "table_service_enabled",
        },
        {
            label: "menu.modify.collection",
            Component: FormSwitchWithText,
            formProps: {
                // secondLabel: "menu.modify.delivery",
            },

            gridColumnOptions: {
                formCol: 6
            },
            keyName: "collection_enabled",
        },
        {
            label: "menu.subcategories.extraItems",
            keyName: "extra_items",
            Component: FormDnDList,
            formProps: {
                selectOptions: extraItems as any,
                selectOptionsName: "name_public",
                selectOptionsValue: "id",
                infoMessage: "menu.modify.extraInfo",
                placeholder: "menu.modify.extraplaceholder",
                selectKeyName: 'name_public',
                selectKeyValue: 'id'
            },
            gridColumnOptions: {
                formCol: 12
            },
        },
        {
            label: "menu.subcategories.preferences",
            keyName: "preference_tags",
            Component: FormTags,
            formProps: {
                selectOptions: preferenceItems as any[],
                getOptionLabel: (option: IPreference) => option.name_public,
                multiple: true,
                selectKeyValue: "id"
            },
            gridColumnOptions: {
                formCol: 6
            },
        },
        {
            label: "menu.subcategories.allergens",
            keyName: "tags",
            Component: FormTags,
            formProps: {
                selectOptions: dietaryTags as any[],
                getOptionLabel: (option: any) => option?.name_public,
                multiple: true,
                selectKeyValue: "id"
            },
            gridColumnOptions: {
                formCol: isEposNow ? 12 : 6
            }
        },
        {
            keyName: "url_photo",
            label: "menu.subcategories.image",
            Component: FormImageManipulator,
            formProps: {
                typeOfFile: "logo",
                crop: { unit: "%", aspect: 1 / 1 },
                hasDelete: true,
            },
        },
        {
            label: "menu.priceoptions.title",
            keyName: "pricing_options",
            Component: DynamicFormExtender,
            inputProperties:
            {
                type: "integer"
            },
            formProps:
            {
                Component: PricingOption,
                secondLabel: 'menu.subcategories.selectPricingOptions',
                createNewObjectFunction: createPricingOption, buttonLabel: 'menu.priceoptions.button'
            },
        }, {
            label: "menu.priceoptions.extratitle",
            keyName: "pricing_options_extras",
            Component: ExtrasFormComponent,
            formProps: {
                secondLabel: "menu.priceoptions.extrasecondtitle",
                removeAddToExtraGroup: removeAddToExtraGroup,
                selectOptions: extraItems as any,
                multiple: true,
            },
        },
    ];

    if (props?.item?.id) {
        formRows = [...formRows, {
            label: "delete.label",
            Component: DeleteItems,
            formProps: {
                rawProps: props, callAPI: props.menuItemAPICall, ParentComponent: ProductModifyDialog,
                item: props.item, keyLabel: "items", onDelete, closeAllModals: () => props.history.goBack(),
                onFailedInteraction:onFailedInteraction
            },
            keyName: "delete",
        }];
    }

    if (menusList?.length) {
        formRows.splice(5, 0,
            {
                label: "menu.products.AddToMenu",
                keyName: "menus",
                Component: FormTags,
                formProps: {
                    selectOptions: menusList as any[],
                    getOptionLabel: (option: any) => option.name_public,
                    multiple: true,
                    selectKeyValue: "id",
                    infoBoxTextLabel: "menu.products.AddToMenuInfoBox",
                    value: []
                },
                gridColumnOptions: {
                    formCol: 12
                }
            })

    }


    return formRows;
}
